module.exports = __webpack_public_path__ + "img/yuexinyan_gzh.4993bef3.jpg";